import { Record } from 'immutable';

import { EditableReport, ReportFormRecordBase } from '../../common/forms/reportForm/records';

import { IReportCreateState } from '../types';

export const ReportCreateState = Record<IReportCreateState>({
  newReport: EditableReport,
  ...ReportFormRecordBase
});
